<template>
  <div>
    <div class="control has-icons-right">
      <input
        ref="autocomplete"
        :placeholder="placeholder"
        class="search-location input"
        type="text"
        v-model="addressTyping"
      />
      <span class="icon is-small is-right">
        <i class="fa fa-search"></i>
      </span>

      <input type="hidden" v-model="selectedAddress" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      selectedAddress: "",
      addressTyping: ""
    };
  },

  watch: {
    addressTyping: function() {
      this.$emit("addressTyping", this.addressTyping);
    },
    selectedAddress: function() {
      this.$emit("address", this.selectedAddress);
      this.$emit("addressPropertyNo", "0");
    }
  },

  methods: {
    initMap() {
      console.log("lib loaded");
    }
  },

  mounted() {
    let defaultBounds = new google.maps.LatLngBounds(
      // new google.maps.LatLng(-44.239531, 111.155395),
      // new google.maps.LatLng(-10.263896, 157.210081));
      new google.maps.LatLng(-34.8667, 138.4737),
      new google.maps.LatLng(-34.7745, 138.6626)
    );

    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { bounds: defaultBounds },
      { types: ["address"] }
    );

    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      let ac = place.address_components;
      let address = place.formatted_address;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let city = ac[0]["short_name"];

      this.addressTyping = address;
      this.selectedAddress = address;
      //console.log(`The user picked ${address} with the coordinates ${lat}, ${lon}`);
    });

    // geolocate() {
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(function(position) {
    //       let geolocation = {
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude
    //       };
    //       let circle = new google.maps.Circle({
    //         center: geolocation,
    //         radius: position.coords.accuracy
    //       });
    //       autocomplete.setBounds(circle.getBounds());
    //     });
    //   }
    // }
  }
};
</script>

<style>
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

.search-location {
  display: block;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/address/GoogleAddressAutocomplete.vue